import { QUESTION_BLOCKS, type QuestionBlock } from "./types";

/**
 * The blocks asked when the admin has not chosen any for the claim: the defaults of the
 * claim's Office ID or travel agency (`passenger_question_blocks`, TECH-1352; `[]` for none) when set,
 * otherwise none: only « Avez-vous déjà réclamé ? » is asked (TECH-1367, the team's choice).
 * `claimTypeName` stays in the signature for a per-incident default.
 */
export function defaultQuestionBlocks(
  _claimTypeName: string | null | undefined,
  agencyBlocks?: readonly string[] | null,
): QuestionBlock[] {
  if (Array.isArray(agencyBlocks)) {
    return QUESTION_BLOCKS.filter((block) => agencyBlocks.includes(block));
  }

  return [];
}

/**
 * The blocks actually asked: the admin's choice when there is one (`claims.passenger_question_blocks`),
 * the defaults of the agency or of the incident type otherwise. Unknown keys (a block removed since)
 * are dropped.
 */
export function resolveQuestionBlocks(
  claimTypeName: string | null | undefined,
  configured: readonly string[] | null | undefined,
  agencyBlocks?: readonly string[] | null,
): QuestionBlock[] {
  if (!Array.isArray(configured)) {
    return defaultQuestionBlocks(claimTypeName, agencyBlocks);
  }

  return QUESTION_BLOCKS.filter((block) => configured.includes(block));
}

export function isQuestionBlock(value: unknown): value is QuestionBlock {
  return typeof value === "string" && (QUESTION_BLOCKS as readonly string[]).includes(value);
}
